import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';

import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

import {CustomValidators} from '../../core/validator/custom-validators';
import {ValidatorService} from '../../core/validator/validator.service';


@Component({
  selector: 'app-dialog-expenses-claim',
  templateUrl: './dialog.expenses-claim.component.html'
})
export class DialogExpensesClaimComponent implements OnInit {

  @Output() editExpensesClaimRequest = new EventEmitter<number>();
  value = 0;
  expensesForm: FormGroup;

  constructor(public activeModal: NgbActiveModal,
              private validatorService: ValidatorService) {
  }

  ngOnInit() {
    this.expensesForm = new FormGroup({
      'expenses': new FormControl('', [Validators.max(50000), Validators.min(0),
        CustomValidators.validateDecimal, CustomValidators.notEmpty])
    });
  }

  onSave() {
    this.validatorService.validate(this.expensesForm);
    if (!this.validatorService.isValid(this.expensesForm)) {
      return;
    }
    this.editExpensesClaimRequest.emit(this.value);
    this.activeModal.close(true);
  }

  onClose() {
    this.activeModal.close(false);
  }

  dismiss(s: string) {
    this.activeModal.dismiss(s);
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/ecv-project/dialog/dialog.expenses-claim.component.ts